import { render, staticRenderFns } from "./PayServiceChargePackage.vue?vue&type=template&id=15d35a92&"
import script from "./PayServiceChargePackage.vue?vue&type=script&lang=js&"
export * from "./PayServiceChargePackage.vue?vue&type=script&lang=js&"
import style0 from "./PayServiceChargePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports